import { apiClient } from './client'

export interface DownloadEntry {
  code: string
  platform: string
  architecture: string
  url: string | null
  versionName: string | null
  available: boolean
}
export type MobilePlatform = 'ANDROID' | 'IOS' | 'HARMONYOS' | 'UNKNOWN'
export interface DownloadContext {
  platform: MobilePlatform
  brand: string
  environment: 'WECHAT' | 'BROWSER'
}
export interface DownloadResolution {
  recommended: DownloadEntry | null
  fallback: DownloadEntry | null
  choosePlatform: boolean
  openInBrowser: boolean
  message: string
}
async function getData<T>(path: string, params?: DownloadContext): Promise<T> {
  const { data } = await apiClient.get<{ code: number; message: string; data: T }>(path, { params })
  if (data.code !== 0) throw new Error(data.message)
  return data.data
}
export const getDownloadEntries = () => getData<DownloadEntry[]>('/v1/platform/downloads')
export const getAppDownloadQr = () =>
  getData<{ appDownloadQrCodeUrl: string | null }>('/v1/platform/downloads/qr-code')
export const resolveDownload = (params: DownloadContext) =>
  getData<DownloadResolution>('/v1/platform/downloads/resolve', params)
